var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 6,
    fill: "#0A66C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_3772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 9.44346C6.875 8.82408 7.09179 8.3131 7.52534 7.91053C7.95889 7.50793 8.52253 7.30664 9.21622 7.30664C9.89753 7.30664 10.4488 7.50483 10.8699 7.90124C11.3035 8.31002 11.5203 8.84266 11.5203 9.49921C11.5203 10.0938 11.3097 10.5893 10.8885 10.9857C10.455 11.3945 9.88514 11.5989 9.17905 11.5989H9.16047C8.47916 11.5989 7.92793 11.3945 7.50676 10.9857C7.08558 10.5769 6.875 10.0628 6.875 9.44346ZM7.11655 25.7019V13.2897H11.2416V25.7019H7.11655ZM13.527 25.7019H17.652V18.7712C17.652 18.3376 17.7016 18.0031 17.8007 17.7678C17.9741 17.3466 18.2373 16.9905 18.5904 16.6994C18.9434 16.4083 19.3863 16.2627 19.9189 16.2627C21.3063 16.2627 22 17.198 22 19.0685V25.7019H26.125V18.5854C26.125 16.752 25.6914 15.3615 24.8243 14.4139C23.9572 13.4663 22.8114 12.9925 21.3868 12.9925C19.7889 12.9925 18.5439 13.68 17.652 15.055V15.0921H17.6334L17.652 15.055V13.2897H13.527C13.5518 13.6861 13.5642 14.9187 13.5642 16.9874C13.5642 19.0561 13.5518 21.9609 13.527 25.7019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_3772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 19.25,
    fill: "white",
    transform: "translate(6.875 6.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon04);
export default __webpack_public_path__ + "static/media/social-icon-04.66a42e552628b4b5637ae5871bad4c78.svg";
export { ForwardRef as ReactComponent };